import { NsAlert } from 'components/common/ns-alert/NsAlert';
import { NsAnchor } from 'components/common/ns-anchor/NsAnchor';

export const testId = 'residentialBankAccount422ErrorTestId';
export const agentTestId = 'agentResidentialBankAccount422ErrorTestId';

type ErrorComponentProps = {
  message?: string;
  title?: string;
  messageForAgent?: string;
};


const ErrorComponent = ({ message, title, messageForAgent }: ErrorComponentProps) => {
  return (
    <NsAlert state="warning" heading={title} testId={testId}>
      {messageForAgent ? (
        <p data-testid={agentTestId}>{messageForAgent}</p>
      ) : (
        <p>{message}</p>
      )}
      <p>
        <NsAnchor href="#paymentDetails">Edit your payment details</NsAnchor>
      </p>
    </NsAlert>
  );
};
const ResidentialSupplyAddress422Error = ErrorComponent;
const ResidentialNonSupplyAddress422Error = ErrorComponent;

export {
  ResidentialSupplyAddress422Error,
  ResidentialNonSupplyAddress422Error
};
